import { connect } from 'react-redux';
import { entitySelectors } from '@store/entity/selectors';
import { CategoriesV2 } from './CategoriesV2';

const mapStateToProps = (state) => ({
  categories: entitySelectors.getAllCategories(state),
});

export const CategoriesV2Container = connect(mapStateToProps)(CategoriesV2);
